
<template>
  <div class="card card-front front-card" v-if="room.info">
    <header class="card-header">
      <div class="status full-status" :style="{'background-color': $store.getters.getStatusOfRoom(room.did).color}"></div>
      <div class="ob-header card-header">
        <div class="card-title">
          <h3 @click="navRoom" class="card-nav-room">{{truncate(room.info.hvacName, 16, 14)}}</h3>
          <h6>{{truncate($store.getters.getActiveBuilding().info.name, 20, 17)}}<span style="color:gray;"> : : </span>{{floorName()}}</h6>
          <h5 class="battery" :style="{'color': setBat().color}"><img :src="setBat().img" />{{(room.meas && room.meas.bat) ? room.meas.bat : '-'}}%</h5>
        </div>
        <div class="room-aux-tabs">
          <div class="ob-img card-settings" @click="$emit('initFlip', {from: 'front', to: 'settings'})">
            <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/gearsWhite.png"/>
          </div>
        </div>
      </div>
      <div class="utility-belt">
        <div class="utility-node" @click="refresh">
          <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/reload.png" />
        </div>
      </div>
      <div class="card-head-sep"></div>
    </header>
    <div class="card-body">
      <div class="card-info" style="margin-bottom:10px;" v-if="!room.parent || room.parent === true">
        <img class="p-or-c" v-if="room.parent && (!parent || !parent.info)" src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/parent.png" />
        <div class="card-info-head" style="justify-content:center;">
          <v-popover offset="3" trigger="hover" placement="right" style="height:15%;">
            <img style="margin-left:10px;"src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/acHeart.png" />
            <template slot="popover">
              <hover-component :options="{type: 'mini', text: 'Equipment Conditions'}"></hover-component>
            </template>
          </v-popover>
        </div>
        <div class="vert-separator head-separator"></div>

        <div v-if="room.info.coilSensor" class="filter-rdg">
          <img src="@/assets/coilFlow.png" />
          <h2
            :style="{'color': $store.getters.rdgStatus({rdg: 'deltaPressure95Percentile', did: room.did}).color}">
              {{$store.state.user.pressure ? room.meas.deltaPressure95Percentile : (room.meas.deltaPressure95Percentile/249.082).toFixed(2)}}
              <span style="font-size:.6em">{{ $store.state.user.pressure ? 'Pa' : 'iwg'}}</span>
            </h2>
          <h5>Coil<br />Pressure</h5>
        </div>

        <div v-else class="filter-rdg">
          <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/filterOfficial.png" />
          <!-- <h2 :style="{'color': $store.getters.rdgStatus({rdg: 'days', did: room.did}).color}">{{(room.meas && (room.meas.days || room.meas.days == 0 )) ? room.meas.days.replace('no data', '-') : '-'}}</h2> -->
          <h2 :style="{'color': $store.getters.rdgStatus({rdg: 'days', did: room.did}).color}">{{room.meas.days}}</h2>
          <h5 v-if="$store.state.lang === 'en'">Days <br /> Remaining</h5>
          <h5 v-else>{{clauses.daysRem}}<br /><span style="opacity:0">hide</span></h5>
        </div>
        <div class="vert-separator"></div>
        <div class="filter-rdg">
          <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/calendar.png" />
          <h5 v-if="room.info.coilSensor" style="color:gray">Calculating...</h5>
          <h2 v-else :style="{'color': $store.getters.rdgStatus({rdg: 'days', did: room.did}).color}">{{setChangeDate()}}</h2>
          <h5 v-if="$store.state.lang === 'en'">Projected <br /> Maintenance</h5>
          <h5 v-else>{{clauses.proj}}</h5>
        </div>
      </div>
      <div class="card-info" style="margin-bottom:10px;" v-else>
        <div class="card-info-head">
          <v-popover offset="3" trigger="hover" placement="right">
            <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/acHeart.png" />
            <template slot="popover">
              <hover-component :options="{type: 'mini', text: 'Equipment Conditions'}"></hover-component>
            </template>
          </v-popover>
        </div>
        <div class="vert-separator head-separator"></div>
        <div class="filter-rdg">
          <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/filterOfficial.png" />
          <h2 style="color:gray;">{{(parent.meas && (parent.meas.days || parent.meas.days == 0)) ? parent.meas.days : '-'}}</h2>
          <h5 v-if="$store.state.lang === 'en'">Days <br /> Remaining</h5>
          <h5 v-else>{{clauses.daysRem}}<br /><span style="opacity:0">hide</span></h5>
        </div>
        <div class="vert-separator"></div>
        <div class="filter-rdg">
          <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/calendar.png" />
          <h2 style="color:gray;">{{setChangeDate(parent)}}</h2>
          <h5 v-if="$store.state.lang === 'en'">Projected <br /> Maintenance</h5>
          <h5 v-else>{{clauses.proj}}</h5>
        </div>
        <div class="parent-overlay">
          <img class="p-or-c" v-if="parent && parent.info" src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/child.png" />
            <h6>Area Supplied by <span :style="{color: $store.getters.rdgStatus({rdg: 'days', did: parent.did}).color}">{{truncate(parent.info.hvacName, 25, 21)}}</span></h6>
        </div>
      </div>
      <div class="card-info" style="position:relative;">
        <div class="card-info-head">
          <v-popover offset="3" trigger="hover" placement="right">
            <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/airHeart.png" />
            <template slot="popover">
              <hover-component :options="{type: 'mini', text: 'Environment Conditions'}"></hover-component>
            </template>
          </v-popover>
        </div>
        <div class="vert-separator head-separator"></div>
        <div class="vert-rdgs">
          <div class="card-rdg">
            <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/temp.png" />
            <h5 :style="{'color': $store.getters.rdgStatus({rdg: 'ttp', did: room.did}).color}">{{(room.meas && room.meas.ttp) ? setTemp(room.meas.ttp) : '-'}}</h5>
          </div>
          <div class="hor-separator"></div>
          <div class="card-rdg">
            <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/hum.png" />
            <h5 :style="{'color': $store.getters.rdgStatus({rdg: 'hhm', did: room.did}).color}">{{(room.meas && room.meas.hhm) ? room.meas.hhm : '-'}}%</h5>
          </div>
        </div>
        <div class="vert-separator"></div>
        <div class="vert-rdgs">
          <v-popover offset="10" trigger="hover" placement="right"class="card-rdg">
            <div class="card-rdg" style="width:75px;justify-content:space-between;">
              <img style="height:30px;" src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/iaq.png" />
              <h6 v-if="room.meas.calibFlag" :style="{'color': 'rgb(0, 153, 191)'}"><br />Calib...</h6>
              <h5 v-else :style="{'color': $store.getters.rdgStatus({rdg: 'iaq', did: room.did}).color}">{{(room.meas && room.meas.iaq) ? room.meas.iaq : '-'}}</h5>
            </div>
            <template slot="popover">
              <hover-component :options="hoverOptions('iaq')"></hover-component>
            </template>
          </v-popover>
          <div class="hor-separator"></div>
          <div class="card-rdg">
            <v-popover offset="10" trigger="hover" placement="right"class="card-rdg">
              <div class="card-rdg" style="width:75px;justify-content:space-between;">
                <img style="height:30px;margin:5px;" src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/eCO2Text.png" />
                <h6 v-if='room.meas.calibFlag' :style="{'color': 'rgb(0, 153, 191)'}">Calib...</h6>
                <h5 v-else class="co2-text" :style="{'color': $store.getters.rdgStatus({rdg: 'co2', did: room.did}).color}">{{(room.meas && room.meas.co2 && parseInt(room.meas.co2)) ? Math.round(room.meas.co2) : '-'}}<br /><span style="font-size:.7em;line-height:.2em;">ppm</span></h5>
              </div>
              <template slot="popover">
                <hover-component :options="hoverOptions('co2')"></hover-component>
              </template>
            </v-popover>
          </div>
        </div>
        <div :class="`vert-rdgs vert-${vocActive ? 'out' : 'in'}`">
          <div class="card-rdg" :style="{'flex-direction': showVOC() ? 'row' : 'column'}">
            <img style="height: 40px;" src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/tvocWithText.png" />
            <h5 v-if="showVOC()" :style="{'color': vocStatus(room.meas.voc), 'margin-top': showVOC() ? '' : '2px'}">{{room.meas.voc}}
              <br/>
              <span v-if="showVOC()">ppm</span>
            </h5>
            <h6 v-else style="margin:0px;color:rgb(0,153,191);margin-bottom:5px;">Calibrating</h6>
          </div>
          <!-- <div class="voc-acc">
              <div class="acc-node" v-for="(acc, accIndex) in ['96fa87', 'f6d857', 'f32b43']" :style="{
                background: accColor(accIndex),
                border: `1px solid ${accColor(accIndex, true)}`
              }"></div>
          </div>
          <h5 style="color:#dce1ec;margin:1px;display:flex;justify-content:center;align-items:center;font-size:.7em;margin-left:8px;">Accuracy
            <v-popover offset="10" trigger="hover" placement="right" class="card-rdg" style="height:14px;width:100%;cursor:default;">
              <span style="font-size:.5em;width:10px;height:10px;border:.5px solid darkgray;border-radius:100%;display:flex;justify-content:center;align-items:center;margin-left:3px;margin-bottom:8px;cursor:default;">i</span>
              <template slot="popover">
                <hover-component :options="hoverOptions('voc')"></hover-component>
              </template>
            </v-popover>
          </h5> -->
        </div>
        <div :class="`voc-tab${vocActive ? ' active-voc' : ''}`">
          <h6 @click="vocActive = vocActive ? false : true">{{vocActive ? 'Back' : 'More'}}</h6>
        </div>
      </div>
    </div>
    <toggle-component :curr="1" v-on:flip="$emit('initFlip', {from: 'front', to: $event})"></toggle-component>
    <div class="refresh-overlay" v-if="refreshing">
      <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/reload.png" />
    </div>
    <small>{{clauses.lastUp}}: {{normalizeUpdated()}} <img style="width:19px;margin-left:10px;position:absolute;right:8%;bottom:0px;" :src="onOffImg().img" /></small>
  </div>

</template>

<script>

import moment from 'moment';
import cToF from 'celsius-to-fahrenheit';

import Lang from '@/lib/langTemplates/CardTemplate';

import Toggle from './Toggle';
import Hover from '../hover/Hover';

export default {

  data(){
    return {
      refreshing: false,
      room: {},
      vocActive: false
    }
  },

  props: ['rm', 'status', 'refsh'],

  components: {
    'toggle-component': Toggle,
    'hover-component': Hover
  },

  computed: {
    clauses(){
      let lPref = this.$store.state.lang;
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    }
  },

  methods: {

    setBat(){
      let batInfo;
      if (!this.room.meas || !this.room.meas.bat || !parseInt(this.room.meas.bat)) {
        batInfo = {color: '#545457', img: 'bat'};
      } else {
        const bat = this.room.meas.bat;
        if (bat > 50) {
          batInfo = {color: '#71C076', img: 'goodBattery'};
        } else if (bat > 25) {
          batInfo = {color: '#E6A752', img: 'averageBattery'};
        } else {
          batInfo = {color: '#f32b43', img: 'badBattery'};
        }
      }
      batInfo.img = `https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${batInfo.img}.png`;
      return batInfo;
    },

    truncate(name, max, end){
      return name.length < max ? name : name.substr(0, end) + '...'
    },

    floorName(){
      let fName = this.$store.getters.getActiveFloor().info.name;
      fName = fName.replace(/Floor/g, this.clauses.floor);
      return fName
        ? this.truncate(fName, 20, 17)
        : `${this.clauses.floor} ${this.$store.getters.getActiveFloor().info.index}`;
    },

    setChangeDate(parent){
      const entity = !parent ? this.room : this.parent;
      if (!entity.meas || !entity.meas.days || entity.meas.days === '-' || entity.meas.days == 'no data') {
        return '-'
      } else {
        let then = Date.now() + (86400000 * entity.meas.days);
        return moment(then).format('MMM-DD');
      }
    },

    setTemp(){
      if (parseInt(this.room.meas.ttp) && this.room.meas.ttp !== 'no data') {
        return this.$store.state.user.metric
          ? Math.round(this.room.meas.ttp) + '˚C'
          : Math.round(cToF(this.room.meas.ttp)) + '˚F';
      } else {
        return '-';
      }
    },

    normalizeUpdated(){
      return this.room.meas && this.room.meas.tms
        ? moment(this.room.meas.tms * 1000).format(this.$store.state.user.metric ? 'MMM-DD @ HH:mm' : 'MMM-DD @ h:mm A')
        : '-';
    },

    async refresh(){
      this.refreshing = true;
      const room = await this.$store.dispatch('refreshRoom', this.room.did);
      this.room = room;
      setTimeout(() => this.refreshing = false, 4000);
    },

    navRoom(){
      if (!this.$store.state.roomIndex) {
        this.$store.dispatch('setRoom', {id: this.room.did, breakpoint: this.$screen.breakpoint});
      }
    },

    setHoverDelay(){
      return {show: 1500, hide: 100};
    },

    hoverOptions(trgt){
      let options = {type: 'media'};
      switch (trgt){
        case 'iaq':
          options.src = 'IAQPlacard';
        break;
        case 'co2':
          options.src = 'CO2ePlacard';
        break;
        case 'voc':
          options.src = 'vocPlacard';
      }
      return options;
    },

    envOptions(){
      return {
        content: 'Environment Conditions',
        trigger: 'click'
      }
    },

    onOffImg(){
      const room = this.parent ? this.parent : this.room;
      const hvacOn = room.meas && room.meas.run ? true : false;
      return {
        img: require(hvacOn ? '@/assets/on.png' : '@/assets/off.png'),
        text: hvacOn ? 'HVAC ON' : 'HVAC OFF'
      }
    },

    vocStatus(voc){
      if (this.room.meas && this.room.meas.voc && this.room.meas.voc != 'no data' && (!this.room.alerts.voc || (!this.room.alerts.voc.bad && !this.room.alerts.voc.crit))) {
        return '#96fa87';
      } else if (this.room.alerts.voc.bad) {
        return '#f6d857';
      } else if (this.room.alerts.voc.crit) {
        return '#f32b43';
      } else {
        return 'rgb(0, 153, 191)';
      }
    },

    popoverOptions(){
      return {
        type: 'full',
        temp: 'Util',
        instance: 'tVOC Accuracy'
        // instance: 'Current Alerts',
        // replacers: [{from: 'warn', to: this.header.alerts ? this.header.alerts.bad : 0}, {from: 'crit', to: this.header.alerts ? this.header.alerts.crit : 0}]
      }
    },

    accColor(index, border){
      if (!this.showVOC()) {
        return border ? '#dce1ec' : 'none';
      } else {
        let color = '';
        switch (this.room.meas.vAC) {
          case 0:
            color = border ? '#dce1ec' : 'none';
          break;
          case 1:
            color = '#f32b43';
          break;
          case 2:
            color = '#f6d857';
          break;
          case 3:
            color = '#96fa87';
          break;
        }
        if (border) {
          return index + 1 <= this.room.meas.vAC ? color : '#dce1ec';
        } else {
          return index + 1 <= this.room.meas.vAC ? color : 'none';
        }
      }
    },

    showVOC(){
      let show = false;
      if (this.room.meas) {
        if (this.room.meas.calibFlag) {
          show = false;
        } else {
          if (!this.room.meas.voc) {
            try {
              if (this.room.meas.voc.toString() === '0') {
                show = true;
              }
            } catch(err) {
              show = false;
            }
          } else {
            show = this.room.meas.vAC > 0 && this.room.meas.voc !== 'no data' && this.room.meas.voc <= .734;
          }
        }
      }
      return show;
    }

  },

  mounted(){
    this.room = this.rm;
    if (this.room.info.hvacName.includes('DEMO')) console.log({ROOM: this.room.info.hvacName, MEAS: this.room.meas});
    if (this.room.parent && typeof this.room.parent == 'string') this.parent = this.$store.getters.getParentRoom(this.room.parent) || false;
  },

  watch: {
    '$screen.breakpoint': function(newData, oldData){
      if (
        newData !== 'sm'
        && this.$store.state.activeRooms.length
        && this.$store.state.activeRooms[0].did
        && this.$store.state.activeRooms[0].did === this.room.did
      ) this.$router.push({path: '/room'});
    },
    refsh: function(newData, oldData){
      this.refresh();
    }
  }

}

</script>

<style>

.front-card {
  border: 2px solid gray;
  overflow: hidden;
  cursor: default;
}

.front-card .tooltip .tooltip-inner {
  width: 250px;
  text-align: center;
}

.card-settings {
  width: 50px;
  height: 40px;
  background-color: rgb(0, 153, 191);
  border-right: none;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  padding: 5px;
  margin-top: 7px;
  margin-bottom: 7px;
  cursor: pointer;
}

.card-settings img {
  height: 35px;
}

.front-card small {
  position: absolute;
  bottom: 1%;
  width: 100%;
  text-align: center;
}

.battery {
  width: 60px;
  margin: 2px;
  margin-left: 1.5%;
}

.card-info-head {
  /* background-color: #325468; */
  width: 25%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* border-right: 2px solid rgb(0, 153, 191); */
}

.card-info-head img {
  width: 45px;
}

.vert-rdgs {
  width: calc(37.5% - 1px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.card-rdg {
  width: 75%;
  height: calc(40% - 1px);
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.filter-rdg {
  width: calc(37.5% - 1px);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.filter-rdg img {
  height: 20%;
  margin: 10px;
}

.filter-rdg h2 {
  margin: 6px;
}

.filter-rdg h5 {
  font-weight: lighter;
  text-align: center;
  margin: 10px;
}

.card-rdg img {
  height: 40%;
  margin: 5px;
}

.card-rdg h5 {
  font-size: 1.1em;
  overflow: hidden;
}

.vert-separator {
  width: 2px;
  height: 40%;
  background-color: rgb(0, 153, 191);
}

.hor-separator {
  width: 40%;
  height: 2px;
  background-color: rgb(0, 153, 191);
}

.card-opts {
  width: 75px;
  height: 25px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 14px;
  margin-top: 14px;
  align-self: flex-end;
  margin-right: 3%;
}

.opt {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* border-radius: 100%; */
  padding: 2px;
  background-color: rgb(0, 153, 191);
}

.opt img {
  height: 75%;
}

/* .utility-belt {
  width: 100%;
  height: 18px;
  bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
} */

.utility-belt {
  width: 33%;
  height: 18px;
  display: flex;
  justify-content: flex-end;
  /* margin-top: 8px; */
  /* margin-bottom: -28px; */
  align-self: center;
  margin-top: -34.5px;
  position: absolute;
}

.spider-belt {
  position: absolute;
  bottom: 5.5%;
}

.utility-node {
  width: 38px;
  height: 100%;
  margin-left: 15px;
  margin-right: 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.utility-node img {
  width: 18px;
  height: 18px;
}

.spider-node {
  position: absolute;
  bottom: 0px;
  left: 10%;
}

.spider-node img {
  width: 25px;
  height: 25px;
}

.spider-icon {
  height: 45px;
}

.spider-tab {
  background-color: #dce1ec;
  justify-content: center;
}

.spider-tab img {
  margin-left: 10px;
}

.co2-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: visible;
  height: 50px;
}

.spl-rdg {
  width: 100%;
  height: 50%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.voc-tab {
  position: absolute;
  bottom: 7px;
  right: 6.5px;
  height: 15px;
  align-self: flex-end;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.voc-tab h6 {
  background: rgb(0, 153, 191);
  color: rgb(2, 27, 47);
  padding: 2px;
  padding-left: 7px;
  padding-right: 7px;
  border-radius: 5px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.vert-in {
  position: absolute;
  animation: vertout .25s forwards;
  right: 0%;
  background: rgb(2, 27, 47);
}

.vert-out {
  position: absolute;
  animation: vertin .25s forwards;
  right: -50%;
  background: rgb(2, 27, 47);
}

@keyframes vertout {
  100% {
    right: -50%;
  }
}

@keyframes vertin {
  from {
    right: -50%;
  }
  to {
    right: 0%;
  }
}

.voc-acc {
  width: 45%;
  height: 14px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 8px;
}

.acc-node {
  width: 8px;
  height: 8px;
  border-radius: 100%;
}


.voc-stat-bar {
  height: 30px;
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-start;
  align-items: center;
  margin-top: 5px;
  position: absolute;
  left: 5px;
  bottom: 15px;
}

.voc-stat-bar div {
  width: 5px;
  height: 5px;
}

.voc-stat-crit {
  background: red;
  margin-top: 4px;
}

.voc-stat-bad {
  background: yellow;
  margin-top: 4px;
}

.voc-stat-good {
  background: #71C076;
}

.p-or-c {
  position: absolute;
  width: 19px;
  height: 19px;
  left: 8px;
  top: 8px;
}

.card-nav-room {
  cursor: pointer;
}

.card-nav-room:hover {
  color: lightblue;
}

</style>



// WEBPACK FOOTER //
// src/components/card/Front.vue